import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import { TABLET_WIDTH } from 'Styles/variables/sizes';

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  font-size: ${({ theme: { fontSizes } }) => pxToRem(fontSizes.s)};
  font-weight: bold;
  line-height: 1.43;
  padding: 0;
  cursor: pointer;
  svg {
    transform: rotate(180deg);
    margin-right: ${pxToRem(18)};
  }
  @media screen and (max-width: ${TABLET_WIDTH}) {
    display: flex;
    font-family: 'Arboria';
    margin-bottom: ${pxToRem(20)};
  }
`;

export const FormContainer = styled(FlexContainer)`
  margin-top: ${({ theme: { reference } }) => reference.dimension_24};
  margin-bottom: ${({ theme: { reference } }) => reference.dimension_24};
`;
